import Vue from 'vue';
import vuetify from './plugins/vuetify'

// Vue.mixin({
//   mounted() {
//     // Set word-breaking to 0 for all v-btn instances
//     const vBtns = this.$el.querySelectorAll('.v-btn');
//     vBtns.forEach((vBtn) => {
//       vBtn.style.letterSpacing = '0';
//     });
//   },
// });

Vue.use(vuetify)